import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@nubank/nuds-web/components/Icon/Icon';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const Header = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  width: 100%;
  background-color: transparent;
  text-align: left;
  cursor: pointer;
`;

const SMALL = 'small';
const DEFAULT = 'default';

export function CollapseHeader({
  children,
  iconSize,
  isOpen,
  id,
  handleToggleButton,
  iconToClose,
  iconToOpen,
}) {
  const buttonIcon = isOpen ? iconToClose : iconToOpen;

  return (
    <Header
      id={id}
      type="button"
      onClick={handleToggleButton}
      aria-controls={`${id}-body`}
      aria-expanded={isOpen}
    >
      <Typography
        color={isOpen ? 'primary' : 'black.light'}
        variant="subtitle1"
        strong
      >
        {children}
      </Typography>
      <Box marginLeft="3x">
        <Icon
          name={buttonIcon}
          size={iconSize}
          color={isOpen ? 'primary' : 'black'}
        />
      </Box>
    </Header>
  );
}

CollapseHeader.defaultProps = {
  id: undefined,
  isOpen: false,
  handleToggleButton: () => {},
  iconSize: 'small',
  iconToClose: 'minus',
  iconToOpen: 'plus',
  children: '',
};

CollapseHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  handleToggleButton: PropTypes.func,
  iconSize: PropTypes.oneOf([SMALL, DEFAULT]),
  iconToClose: PropTypes.string,
  iconToOpen: PropTypes.string,
  id: PropTypes.string,
  isOpen: PropTypes.bool,
};
